import React, { Component } from 'react';
import { getUser} from '../Actions/UserActions';

import { connect } from 'react-redux';

import NavBar2 from "./NavBar2";
import SiteFoot from "../Components/SiteFoot";

class outsidegc extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            width: window.innerWidth,
            password: '',
            error: ''
        };
    }
    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

// make sure to remove the listener
// when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }
    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };











    render() {


        var lang
        if(this.props.lang==="zh"||this.props.lang==="zh-hk"||this.props.lang==="zh-cn"||this.props.lang==="zh-sg"||this.props.lang==="zh-tw"|| this.props.lang==="zh-HK"||this.props.lang==="zh-CN"||this.props.lang==="zh-SG"||this.props.lang==="zh-TW"){
            lang= "zh"
        }else{
            lang="en"
        }


        return (
            <div style={{ height: "100%",}}>



                <div  style={{backgroundColor:"white", width: "100%", display: "flex", top: "0", position:"fixed", left: "0px",
                zIndex: "500",  borderStyle: "solid",  borderColor: "FireBrick", borderWidth: "0px 0px 2px 0px"}}>


                <NavBar2/>




                ​

                ​










            </div>
            {this.state.width<500 &&<div style={{height: "16vw",}} ></div>}
            {this.state.width>=500 &&<div style={{height: "10vw", }} ></div>}




                <div>


                <div style={{width: "90%", margin: "auto", display: "block", padding: "0px", fontFamily:"Open Sans, sans-serif"}} >


                    {lang==="en" && <div style={{width: "50%",margin: "auto", maxWidth:"50%", minWidth:"20em",verticalAlign:"top",  display: "inline-block", backgroundColor:"white", padding: "30px",}} >
                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>IP Opinions and Counseling</span><p/>
                        <span style={{fontSize: ".8em"}}>The Morrow Firm has experience representing international and domestic Fortune 500, Nasdaq, and startup companies in a wide range of IP matters. We provide legal opinions and counseling to help our clients navigate and manage IP risks. The legal opinions and counseling we provide include:</span><p/>
                        <ul><span style={{fontSize: ".8em"}}><li>Patent Infringement/Noninfringement</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Patent Validity/Invalidity</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Freedom-to-Operate ("FTO") search and analysis</li></span><br/></ul>
                    </div>}

                    {lang==="zh" && <div style={{width: "50%",margin: "auto", maxWidth:"50%", minWidth:"20em",verticalAlign:"top",  display: "inline-block", backgroundColor:"white", padding: "30px",}} >
                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>知识产权法律意见和咨询</span><p/>
                        <span style={{fontSize: ".8em"}}>沫若律师事务所有代理财富五百强、纳斯达克上市公司和初创公司处理多种知识产权类业务的经验。我们提供法律意见和咨询以帮助我们的客户驾驭和管理知识产权类的风险。 我们提供的法律意见和咨询包括:</span><p/>
                        <ul> <span style={{fontSize: ".8em"}}><li>专利侵权</li></span><p/>
                        <span style={{fontSize: ".8em"}}><li>专利有效性</li></span><p/>
                            <span style={{fontSize: ".8em"}}><li>自由实施("FTO")检索和分析</li></span><p/></ul>
                    </div>}


                    <div style={{width: "49%", maxWidth:"50%", margin: "auto",  display: "inline",  padding: "5px", }} >
                         <img  alt="Outside General Counsel" style={{top:"0px",  minWidth:"20em", maxWidth:"30em", width: "100%"}} src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/gc.jpg?alt=media&token=7793de1b-2ec0-4f34-8c8c-de1ba5f4b64d"/>
                    </div>


            </div>


            </div>
            <SiteFoot lang={lang}/>
        </div>


    );
    }
}

function mapStateToProps(state, ownProps) {
    return { user: state.user, admin: state.admin, lang: state.lang  };
}

export default connect(mapStateToProps, {  getUser })(outsidegc);



// WEBPACK FOOTER //
// ./src/Containers/outsidegc.js